// import React from "react"
// import { Col, Container, Row } from "react-bootstrap"
// import FooterPrimaryLogo from '../../../assets/images/landking-logo-transparent.png'
// import FooterSecondaryLogo from '../../../assets/images/boabah-logo.png'
// import BtatcFooterText from '../../../assets/images/btatc-text.png'
// import BtatcFooterLogo from '../../../assets/images/logo-btatc.png'
// import './Footer.css'
// import { Link } from "react-router-dom"
// import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin, FaSnapchat, FaTiktok } from "react-icons/fa";
// import { FaSquareXTwitter } from "react-icons/fa6";



// export default function Footer() {
//     const currentYear = new Date().getFullYear();

//     return (
//         <footer className="main-footer">
//             <Container fluid>
//                 <Row className="align-items-end logo-row">
//                     <Col md={6}>
//                         <div className="logo-primary">
//                             <img src={FooterPrimaryLogo} />
//                         </div>
//                     </Col>
//                     <Col md={6}>
//                         <div className="float-md-end">
//                             <div className="d-flex align-items-center">
//                                 <div className="logo-footer-btatc-text">
//                                     <img src={BtatcFooterText} />
//                                 </div>
//                                 <div className="logo-footer-btatc-logo">
//                                     <img src={BtatcFooterLogo} />
//                                 </div>
//                             </div>
//                             {/* <div className="logo-secondary">
//                                 <img src={FooterSecondaryLogo} />
//                             </div> */}
//                         </div>
//                         {/* <div className="logo-secondary float-md-end">
//                             <div className="d-flex">


//                             </div>

//                         </div> */}
//                     </Col>
//                 </Row>

//                 <Row className="footer-list-row">
//                     <Col md={3}>
//                         <h4 className="footer-title">Our Products</h4>
//                         <ul className="footer-list">
//                             <li>
//                                 <Link to="/vehicles/h-series">LANDKING H-Series</Link>
//                             </li>
//                         </ul>
//                     </Col>

//                     <Col md={3}>
//                         <h4 className="footer-title">About BTATC</h4>
//                         <ul className="footer-list">
//                             <li>
//                                 <Link to="/about-us">Know More About Us</Link>
//                             </li>

//                             {/* <li>
//                                 <Link to="/">News & Updates</Link>
//                             </li>


//                             <li>
//                                 <Link to="/">Careers</Link>
//                             </li>

//                             <li>
//                                 <Link to="/">BTATC Offers</Link>
//                             </li>

//                             <li>
//                                 <Link to="/">BTATC Warranty</Link>
//                             </li> */}
//                         </ul>
//                     </Col>

//                     <Col md={3}>
//                         <h4 className="footer-title">Useful Links</h4>
//                         <ul className="footer-list">
//                             <li>
//                                 <Link to="/privacy-policy">Privacy Policy</Link>
//                             </li>

//                             <li>
//                                 <Link to="/terms-conditions">Terms & Conditions</Link>
//                             </li>


//                             <li>
//                                 <Link to="/faq">FAQ's</Link>
//                             </li>

//                             {/* <li>
//                                 <Link to="/">Services</Link>
//                             </li>

//                             <li>
//                                 <Link to="/">Roadside Assistance</Link>
//                             </li> */}
//                         </ul>
//                     </Col>

//                     <Col md={3}>
//                         <h4 className="footer-title">Reach Us</h4>

//                         <div className="footer-subtitle">
//                             <h5>Support Email Address</h5>
//                             <a href="#">info@btatc.com</a>
//                         </div>

//                         <div className="footer-subtitle">
//                             <h5>Toll-Free Number</h5>
//                             <a href="#" tel="8001240664" >8001240664</a>
//                         </div>

//                         <ul className="footer-social">
//                             <Link to='https://www.instagram.com/landking.ksa/' target="_blank">
//                                 <li>
//                                     <FaInstagram />
//                                 </li>
//                             </Link>

//                             <Link to='https://www.facebook.com/landking.ksa' target="_blank">
//                                 <li>
//                                     <FaFacebook />
//                                 </li>
//                             </Link>

//                             <Link to='https://x.com/LandkingKsa' target="_blank">
//                                 <li>
//                                     <FaSquareXTwitter />
//                                 </li>
//                             </Link>
//                         </ul>

//                         <ul className="footer-social">
//                             <Link to='https://www.linkedin.com/in/landking-ksa/' target="_blank">
//                                 <li>
//                                     <FaLinkedin />
//                                 </li>
//                             </Link>

//                             <Link to='/'>
//                                 <li>
//                                     <FaSnapchat />
//                                 </li>
//                             </Link>

//                             <Link to='/'>
//                                 <li>
//                                     <FaTiktok />
//                                 </li>
//                             </Link>
//                         </ul>

//                         {/* <div className="footer-subtitle">
//                             <h5>WhatsApp Number</h5>
//                         </div> */}
//                     </Col>
//                 </Row>

//                 <Row className="align-items-center pt-2">
//                     <Col md={4}>
//                     </Col>
//                     <Col md={4}>
//                         <div className="footer-copy">
//                             <p className="text-white text-center">&copy; {currentYear}. All Rights Reserved by BTATC</p>
//                         </div>
//                     </Col>
//                     <Col md={4}>

//                     </Col>
//                 </Row>
//             </Container>
//         </footer>
//     );
// }



import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FooterPrimaryLogo from "../../../assets/images/landking-logo-transparent.png";
import BtatcFooterText from "../../../assets/images/btatc-text.png";
import BtatcFooterLogo from "../../../assets/images/logo-btatc.png";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaLinkedin, FaSnapchat, FaTiktok } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { useTranslation } from "react-i18next";



export default function Footer() {
   const { t, i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith("ar");


    const currentYear = new Date().getFullYear();


    return (
        <footer className="main-footer">
            <Container fluid>
                <Row className="align-items-end logo-row">
                    <Col md={6}>
                        <div className="logo-primary">
                            <img src={FooterPrimaryLogo} alt={t("common.footer.landkingLogoAlt")} />
                        </div>
                    </Col>

                    {/* <Col md={6}>
                        <div className="float-md-end">
                            <div className="d-flex align-items-center">
                                <div className="logo-footer-btatc-text">
                                    <img src={BtatcFooterText} alt={t("common.footer.btatcTextAlt")} />
                                </div>
                                <div className="logo-footer-btatc-logo">
                                    <img src={BtatcFooterLogo} alt={t("common.footer.btatcLogoAlt")} />
                                </div>
                            </div>
                        </div>
                    </Col> */}

                    <Col md={6}>
                        <div className={isArabic ? "float-md-start" : "float-md-end"}>
                            <div className={`d-flex align-items-center ${isArabic ? "ar-row-reverse" : ""}`}>
                                <div className="logo-footer-btatc-text">
                                    <img src={BtatcFooterText} alt={t("common.footer.btatcTextAlt")} />
                                </div>
                                <div className="logo-footer-btatc-logo">
                                    <img src={BtatcFooterLogo} alt={t("common.footer.btatcLogoAlt")} />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="footer-list-row">
                    <Col md={3}>
                        <h4 className="footer-title">{t("common.footer.productsTitle")}</h4>
                        <ul className="footer-list">
                            <li>
                                <Link to="/vehicles/h-series">{t("common.footer.hSeriesLink")}</Link>
                            </li>
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h4 className="footer-title">{t("common.footer.aboutTitle")}</h4>
                        <ul className="footer-list">
                            <li>
                                <Link to="/about-us">{t("common.footer.aboutLink")}</Link>
                            </li>
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h4 className="footer-title">{t("common.footer.usefulLinksTitle")}</h4>
                        <ul className="footer-list">
                            <li>
                                <Link to="/privacy-policy">{t("common.footer.privacyPolicy")}</Link>
                            </li>
                            <li>
                                <Link to="/terms-conditions">{t("common.footer.termsConditions")}</Link>
                            </li>
                            <li>
                                <Link to="/faq">{t("common.footer.faq")}</Link>
                            </li>
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h4 className="footer-title">{t("common.footer.reachUsTitle")}</h4>

                        <div className="footer-subtitle">
                            <h5>{t("common.footer.supportEmailTitle")}</h5>
                            <a href="mailto:info@btatc.com">info@btatc.com</a>
                        </div>

                        <div className="footer-subtitle">
                            <h5>{t("common.footer.tollFreeTitle")}</h5>
                            <a href="tel:8001240664">8001240664</a>
                        </div>

                        <ul className="footer-social">
                            <li>
                                <a
                                    href="https://www.instagram.com/landking.ksa/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                >
                                    <FaInstagram />
                                </a>
                            </li>

                            <li>
                                <a
                                    href="https://www.facebook.com/landking.ksa"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                >
                                    <FaFacebook />
                                </a>
                            </li>

                            <li>
                                <a
                                    href="https://x.com/LandkingKsa"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="X"
                                >
                                    <FaSquareXTwitter />
                                </a>
                            </li>
                        </ul>

                        <ul className="footer-social">
                            <li>
                                <a
                                    href="https://www.linkedin.com/in/landking-ksa/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="LinkedIn"
                                >
                                    <FaLinkedin />
                                </a>
                            </li>

                            <li>
                                <a href="/" aria-label="Snapchat">
                                    <FaSnapchat />
                                </a>
                            </li>

                            <li>
                                <a href="/" aria-label="TikTok">
                                    <FaTiktok />
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>

                <Row className="align-items-center pt-2">
                    <Col md={4}></Col>
                    <Col md={4}>
                        <div className="footer-copy">
                            <p className="text-white text-center">
                                &copy; {currentYear}. {t("common.footer.copyright")}
                            </p>
                        </div>
                    </Col>
                    <Col md={4}></Col>
                </Row>
            </Container>
        </footer>
    );
}